import {
  checkPurchased,
  createOrder,
  mockPayOrder,
  getOrderByNo,
  listOrdersByUserId,
  cancelOrder
} from '@/api/order'

// 检查用户是否已购买AMC课程（兼容旧调用，转到通用订单接口）
export function checkAmcPurchased(userId, courseLevel) {
  return checkPurchased(userId, 'AMC', courseLevel)
}

// 创建AMC课程订单（兼容旧调用，转到通用订单接口）
export function createAmcOrder(data) {
  return createOrder({
    ...(data || {}),
    courseType: 'AMC'
  })
}

// 模拟支付
export function mockPayAmcOrder(orderNo) {
  return mockPayOrder(orderNo)
}

// 根据订单号查询订单
export function getAmcOrderByNo(orderNo) {
  return getOrderByNo(orderNo)
}

// 查询用户的订单列表
export function listAmcOrdersByUserId(userId, courseLevel) {
  return listOrdersByUserId(userId, 'AMC', courseLevel)
}

// 取消订单
export function cancelAmcOrder(orderNo) {
  return cancelOrder(orderNo)
}
